.ux-iws-dynamic-input {
    display: block;
    position: relative;

    .ux-iws-dynamic-input__dynamic-container.is-min-reached {
        ux-icon {
            opacity: 0.3;
            cursor: default;
        }
    }

    .ux-iws-dynamic-input__input-container {
        display: flex;
        align-items: center;
        margin: 0 0 10px;

        ux-icon {
            margin: 0 0 0 20px;
            opacity: 1;
            cursor: pointer;
            transition: opacity 0.2s ease-in-out;
        }
    }

    .ux-text-link {
        display: inline-block;
        cursor: pointer;
        transition: color 0.2s ease-in-out;

        &.is-max-reached {
            color: $color-gray-inactive;
            cursor: default;
        }
    }
}
